import React from 'react';
import classnames from 'classnames';

import { Button, Link } from '@lt/components';
import styles from './linkButton.module.css';

interface ILinkButton {
  href: string;
  children: React.ReactNode;
  className?: string;
}

const LinkButton: React.FC<ILinkButton> = ({ href, children, className }) => (
  <Link
    href={href}
    target="_blank"
    className={classnames(className, styles.link)}
  >
    <Button size="none" className={styles.button}>
      {children}
    </Button>
  </Link>
);

export default LinkButton;
